<!--<div class="col-md-12">-->
<h1 mat-dialog-title>{{ 'scheduler.visitType-detail.sorCodes.title' | translate }} Add</h1>
<!--</div>-->

<!--<mat-progress-bar mode="indeterminate" *ngIf="isLoading"></mat-progress-bar>-->
<!--<mat-card *ngIf="isError">-->
<!--<mat-card-header>-->
<!--{{errorMessage| translate}}-->
<!--</mat-card-header>-->
<!--<mat-card-actions>-->
<!--<button mat-button (click)="retryLoad()">{{ 'scheduler.general.retry' | translate }}</button>-->
<!--</mat-card-actions>-->
<!--</mat-card>-->

<form (ngSubmit)="addVisitType()" [formGroup]="visitForm">

  <mat-icon color="accent">description</mat-icon>
  <mat-form-field>
    <input formControlName="DescriptionFormControl" matInput required type="text">
    <mat-label>Description</mat-label>
    @if (visitForm.controls['DescriptionFormControl']) {
      <mat-error>Please enter description !</mat-error>
    }
  </mat-form-field>

  <mat-dialog-actions>
    <span class="spacer"></span>
    <button (click)="onCancelClick()" mat-flat-button type="reset">{{ 'scheduler.general.cancel' | translate }}</button>
    <button [disabled]="!visitForm.valid" color="primary" mat-raised-button type="submit">Add</button>
  </mat-dialog-actions>

</form>